<template>
  <div class="withdrawal-wrapper">
    <div class="withdrawal-item d-flex flex-wrap">
      <div class="w-100">
        <h2 class="listing-title">收款狀態</h2>
      </div>
      <div class="left-item">
        <span class="withdrawal-item__amount">
          可收取總金額
        </span>
        <span class="withdrawal-item__label">
          {{ formatCurrency(withdrawalOverview.available) }}
        </span>
      </div>
      <div class="divide-line"></div>
      <div class="middle-item">
        <span class="withdrawal-item__amount">處理中款項</span>
        <span class="withdrawal-item__label">
          {{ formatCurrency(withdrawalOverview.pending) }}
        </span>
      </div>
      <!--
      <div class="w-100 nominal">
        <img src="../../assets/img/icon/rise.svg" />
        <span class="up">100%較上月高</span><span>（截至每月截數日）</span>
      </div>
      -->
      <div class="w-100 text-xl-right text-lg-center text-center">
        <b-button variant="primary detail-button"
                  :disabled="loading"
                  class="withdraw"
                  @click="goToPaymentRecords">
          查看詳情
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue';
import formatCurrency from '@/helpers/currency';

export default {
  components: {
    BButton,
  },
  props: {
    role: String,
    loading: Boolean,
    withdrawalOverview: Object,
  },
  data: () => ({
    withdrawIsAllowModal: {
      modal: false,
      action: null,
      remarks: null,
    },
  }),
  methods: {
    goToPaymentRecords() {
      this.$router.push({
        path: this.role === 'merchant' ? '/paymentRecords' : `/${this.role}/paymentRecords`,
      });
    },
    formatCurrency,
  },
};
</script>

<style scoped lang="scss">
.listing-title {
  font-weight: 500;
  margin-bottom: 1rem;
  color: #174169;
  font-size: 18px;
  display: inline-block;

  @media (max-width: 1200px) {
    font-size: 16px;
  }
}

.withdrawal-wrapper {
  display: inline-block;
  width: 40%;

  @media (max-width: 1200px) {
    width: 100%;
  }

  .detail-button {
    width: 112px;
    @media (max-width: 1200px) {
      font-size: 0.95em;
      width: 215px;
    }
  }
}

.withdrawal-item {
  border: 1px solid #dde1e5;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 20px 15px;
  box-sizing: border-box;
  font-size: 0.9em;
  height: 288px;

  @media (max-width: 1200px) {
    height: auto;
  }

  &:hover {
    & img {
      transform: scale(1.06);
    }
  }

  & img.tooltips {
    margin-top: -3px;
  }

  &__label {
    color: #174169;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 36px;
    display: block;
    font-family: Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

    @media (max-width: 1200px) {
      font-size: 18px;
      padding-top: 0px;
    }
  }

  &__amount {
    color: #696969;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 21px;
    display: block;

    @media (max-width: 1200px) {
      font-size: 12px;
    }
  }

  .left-item {
    @include respond(tab-landscape) {
      width: 48%;
    }
    width: 100%;
    display: inline-block;
  }

  .middle-item {
    width: 100%;
    display: inline-block;
    @include respond(tab-landscape) {
      width: 50%;
    }

    @media (max-width: 1200px) {
      margin-top: 0px;
    }
  }

  .withdraw {
    margin-top: 15px;
  }

  .divide-line {
    background: #ccc;
    width: 1px;
    height: 50px;
    margin-top: 10px;
    display: none;
    @include respond(tab-landscape) {
      display: inline-block;
      margin-right: 5px;
    }
  }

  .nominal {
    span {
      font-size:0.85em;
    }

    .up {
      color: #70A450;
    }
  }

  .loading {
    opacity: 0.5;
  }
}
</style>
